import * as React from "react";
import * as ReactDOM from "react-dom";
import Component from "../../AbstractComponent";

import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';

import Constants from "../../../Action/Constants";

export interface LookupConfigInterface {
  entities: any[];
  type: string;
  disableEntityCreation: boolean;
  payloadPrefix: string;
  entityTranslation: string;
  floatingLabelText: string;
  dialogTitle: string;
  dialogType: string;
  buttonLabel: string;
  componentState: any;
  visibilityProperty: string;
  dialogInputToComponentSyncProperty: string;
  filter: any;
  createPage?: string;
  linkedObjectUrl?: string;
  noResultText?: string;
  labelText: string;
}

abstract class AbstractLookup extends Component {
  protected type: string;
  protected componentState = {};
  protected config: LookupConfigInterface;
  protected interval = null;
  public ref = null;

  public state = {
    searchText: "",
    dialogValue: "",
    width: "100%",
    containerWidth: "100%",
    display: "none",
    hasSelectedEntity: false,
    error: this.props.error,
    lastSelectedEntity: null,
    showPromptDialog: false,
    clickedCreateButton: false,
    isDialogOpen: false,
    clickStarted: false,
    autoFocus: !!this.props.autoFocus,
    showTextField: true,
    noScrollAgain: false
  };

  constructor(public props) {
    super(props);

    // If user passed searchText, put it to state
    if (typeof this.props.searchText !== "undefined") {
      this.state.searchText = this.props.searchText;
      this.state.dialogValue = this.props.dialogValue;
    }

    // If user passed width, put it to state
    if (typeof this.props.width !== "undefined") {
      this.state.width = this.props.width;
    }

    // If user passed container width, put it to state
    if (typeof this.props.containerWidth !== "undefined") {
      this.state.containerWidth = this.props.containerWidth;
    }

    this.closeDialog = this.closeDialog.bind(this);
    this.save = this.save.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onClear = this.onClear.bind(this);
    this.openModal = this.openModal.bind(this);
    this.redirectToCreatePage = this.redirectToCreatePage.bind(this);
    this.onPressEnter = this.onPressEnter.bind(this);
  }

  public abstract getEntities();
  public abstract getList();
  public abstract getPayloadFromComponent();
  public abstract syncDialogValue(value);

  public componentWillMount() {
    // Set component state
    Object.keys(this.config.componentState || {}).forEach(key => {
      this.setState({
        [key]: this.config.componentState[key]
      });
    });

    // If we have auto selected index, call onSelect instantly.
    this.autoSelect(this.props.autoSelectId);
  }

  public componentWillReceiveProps(nextProps) {
    const entity = this.getEntities().find(entity => entity.id === nextProps.autoSelectId);

    if (!!entity && typeof entity[this.config.visibilityProperty] !== "undefined" &&
        nextProps.autoSelectId &&
        nextProps.autoSelectId !== this.props.autoSelectId
       ) {
      this.setState({
        searchText: !!entity && entity[this.config.visibilityProperty] ? entity[this.config.visibilityProperty] : "",
        display: "none"
      });
    }

    this.setState({
      hasSelectedEntity: !!entity ? true : false,
      lastSelectedEntity: entity,
      error: nextProps.error
    });
  }

  public componentWillUnmount = () => {
    this.setState({
      noScrollAgain: false
    })
  }

  protected autoSelect(autoSelectId: number): void {
    const entity = this.getEntities().find(entity => entity.id === autoSelectId);

    if (typeof entity === "undefined") {
      return;
    }

    this.onSelect(entity, "autoSelect");
  }

  protected onPressEnter(event) {
    if (event.key === "Enter") {
      if (typeof this.props.onPressEnter !== "undefined") {
        this.props.onPressEnter.call(this);
      }

      return this.save();
    }
  }

  public clear = (autoFocusAfterClear: boolean = true): void => {
    this.setState({
      display: "none",
      searchText: "",
      dialogValue: "",
      hasSelectedEntity: false,
      lastSelectedEntity: null,
      showPromptDialog: false,
      clickedCreateButton: false,
      showTextField: false,
      autoFocus: autoFocusAfterClear ? true : false
    }, () => {
      this.setState({
        showTextField: true
      })
    });
  }

  public onClear(autoFocusAfterClear: boolean = true): any {
    const lastSelectedEntity = this.state.lastSelectedEntity;

    if (typeof this.props.onClear !== "undefined") {
      this.props.onClear.call(this, lastSelectedEntity);
    }

    this.clear(autoFocusAfterClear);
  }

  public hide(): any {
    this.setState({
      display: "none"
    });
  }

  protected onFocus(e) {
    e.preventDefault();
    if (!this.props.withoutScroll) {
      this.setState({
        display: this.state.hasSelectedEntity ? "none" : "block"
      }, () => {
        const element = ReactDOM.findDOMNode(this) as any;
        const elementPosition = element.getBoundingClientRect().top;
        const lookupComponentHeight = 420;
        if ((window.innerHeight - elementPosition) < lookupComponentHeight) {
          if (!this.state.noScrollAgain) {
            if (this.props.scrollToEndOfPage) {
              document.documentElement.style.height = "calc(100% + 650px)";
              var scrollingElement = (document.scrollingElement || document.body);
              scrollingElement.scrollTop = scrollingElement.scrollHeight;
            } else {
              if (window.innerHeight > elementPosition + lookupComponentHeight) {
                window.scrollTo({
                  top: elementPosition + 200,
                  behavior: "smooth"
                });
              }
            }

            this.setState({
              noScrollAgain: true
            });
          } else {
            return;
          }
        }
      });
    }

    if (typeof this.props.onFocus !== "undefined") {
      this.props.onFocus.call(this);
    }
  }

  protected onChange(e) {

    e.preventDefault();

    this.setState({
      display: "block",
      searchText: e.currentTarget.value,
      dialogValue: e.currentTarget.value,
    });

    if (e.currentTarget.value.length === 0) {
      this.onClear();
    }

     if (typeof this.props.onChange !== "undefined") {
       this.props.onChange.call(this, e.currentTarget.value);
     }

  }

  protected setClickStarted = () => {
    //
    this.setState({clickStarted: true});
  }

  protected onBlur = () => {
    if (typeof this.props.selectEntityName !== "undefined" && this.state.searchText !== "" && this.state.clickStarted) {
      this.openModal();
      this.props.selectEntityName.call(this, this.state.searchText, this.props.templateFor);
    }
    if (!this.state.clickStarted) {
      setTimeout(() => {
        this.setState({
          clickStarted: false
        });

        if (!this.state.hasSelectedEntity) {
          this.clear(false);
        }

        if (this.state.hasSelectedEntity === true) {
          this.setState({
            searchText: !!this.state.lastSelectedEntity && this.state.lastSelectedEntity.displayName ? this.state.lastSelectedEntity.displayName : ""
          })
          return;
        }

        if (this.state.searchText?.length === 0) {
          return;
        }

        if (this.state.clickedCreateButton === true) {
          return;
        }

        this.syncDialogValue(this.state.searchText);

        if (this.shouldRedirectToCreatePage() === false) {
          this.setState({
            showPromptDialog: !this.config.disableEntityCreation
          });
        }
      }, 100);
    }
    if (typeof this.props.onBlur !== "undefined" ) {
      setTimeout(() => {
        this.props.onBlur.call(this, this.state.searchText);
      }, 100);
    }

  }

  protected onSelect(entity, previousAction: string) {
    this.setState({
      display: "none",
      searchText: entity[this.config.visibilityProperty],
      dialogValue: "",
      hasSelectedEntity: true,
      lastSelectedEntity: entity,
      showPromptDialog: false,
      clickStarted: false,
      showTextField: false,
      autoFocus: false
    }, () => {
      this.setState({
        showTextField: true
      })
    });

    if (previousAction === "autoSelect") {
      if (typeof this.props.onSelect !== "undefined") {
        return this.props.onSelect.call(this, entity);
      }
    }

    // If we created the entity with create, let's also trigger onCreate.
    if (previousAction === "create") {
      if (typeof this.props.onCreate !== "undefined") {
        this.props.onCreate.call(this, entity, true);
      }
    }

    if (typeof this.props.onSelect !== "undefined") {
      this.props.onSelect.call(this, entity, true);
    }
  }

  protected closeDialog() {
    const state = {
      dialogValue: "",
      searchText: "",
      showPromptDialog: false,
      clickedCreateButton: false,
      isDialogOpen: false
    };

    // Revert back to the default values
    Object.keys(this.config.componentState || {}).forEach(key => {
      state[key] = this.config.componentState[key];
    });

    this.setState(state);
  }

  protected openModal() {
    if (this.props.shouldOpenCoachModal) {
      if(typeof this.props.openPropertyOwnerCoachDialog !== "undefined") {
        this.props.openPropertyOwnerCoachDialog()
      }

      if(typeof this.props.openPoaCoachDialog !== "undefined") {
        this.props.openPoaCoachDialog()
      }

      if(typeof this.props.openTaskExecutorCoachDialog !== "undefined") {
        this.props.openTaskExecutorCoachDialog()
      }

      if(typeof this.props.openPropertyCoachDialog !== "undefined"){
        return this.props.openPropertyCoachDialog();
      }

      if(typeof this.props.openPropertyOwnerCoachDialog !== "undefined"){
        return this.props.openPropertyOwnerCoachDialog();
      }

      if(typeof this.props.openUnitCoachDialog !== "undefined"){
        return this.props.openUnitCoachDialog();
      }

      if(typeof this.props.openCreateCompanyDialog !== "undefined"){
        return this.props.openCreateCompanyDialog();
      }

      this.setState({
        clickStarted: false
      })
    }

    this.setState({
      clickedCreateButton: true,
      isDialogOpen: true
    });

    if (typeof this.props.onNewButtonClick === "undefined") {
      this.syncDialogValue(this.state.dialogValue);
      return;
    }

    this.props.onNewButtonClick.call(this);
  }

  protected showFields() {   
    const res = this.getList().slice(0, this.props.fieldsToShow ? this.props.fieldsToShow : 5);

    if (res.length === 0 && !this.props.hideNotFoundMessage) {
      return (
        <div className="no-results" style={{display: "flex", justifyContent: "center", alignItems: "center", padding: "5px", fontSize: "14px", lineHeight: "14px"}}>
          <h4>{this.props.disableEntityCreation ? this.trans("dropdown-chargeobject-notfound") : this.config.noResultText || this.trans("error-no-results")}</h4>
        </div>
      );
    }

    return res;
  }

  public redirectToCreatePage(): void {
    if (this.props.saveDetailsBeforeRedirect) {
      this.props.dispatch({
        type: Constants.LOOKUP_SEARCHTEXT,
        payload: {
          lookupSearchText : this.state.searchText
        }
      });

      this.props.saveDetailsBeforeRedirect();
    }

    if (this.props.templateFor) {
      if (this.constructor.name === "PersonLookup") {
        this.props.dispatch({
          type: Constants.PERSON_CREATE_PAGE_TEMPLATE,
          payload: {
            template : this.props.templateFor
          }
        });
      }

      if (this.constructor.name === "CompanyLookup") {
        this.props.dispatch({
          type: Constants.COMPANY_CREATE_PAGE_TEMPLATE,
          payload: {
            template : this.props.templateFor
          }
        });
      }
    }

    return this.redirect(this.config.createPage);
  }

  public generatePayload(): any {
    const res = {};

    Object.keys(this.config.componentState || {}).forEach(key => {
      res[key] = this.state[key];
    });

    return {
      [this.config.payloadPrefix]: res
    };
  }

  public handleClickOutside(): void {
    this.setState({
      display: "none"
    });
  }

  protected getStoreAttribute() {
    return `is AbstractLookup Open`;
  }

  protected save() {
    const amount = this.getEntities().length;
    let payload = this.generatePayload();

    // Dialog type big is special. We render whole component here, so we have to read the payload from it's state
    if (this.props.dialogType === Constants.LOOKUP_COMPONENT_DIALOG_TYPE_BIG) {
      payload = this.getPayloadFromComponent();
    }

    if (typeof this.props.addToPayload !== "undefined") {
      Object.keys(this.props.addToPayload || {}).forEach(key => {
        payload[this.config.payloadPrefix][key] = this.props.addToPayload[key];
      });
    }

    this.setState({
      display: "none",
      searchText: payload[this.config.payloadPrefix][this.config.dialogInputToComponentSyncProperty]
    });

    this.props.dispatch({
      type: this.config.type,
      payload: payload
    });

    this.closeDialog();

    /*
    |  @todo fix it properly by hooking Saga responses, so this should trigger only once.
    |  For now (to meet the deadlines...) it will check for array length differences.
    |  If it is bigger, then it means we created a new entity so we can trigger onSelect
    |  to obtain necessary information about this entity on the parent component.
    */

    this.interval = setInterval(() => {
      if (amount < this.getEntities().length) {
        this.onSelect(this.getEntities()[0], "create");
        clearInterval(this.interval);
      }
    }, 100);
  }

  public shouldRedirectToCreatePage(): boolean {
    return this.props.forceUpdatePage === true && this.config.createPage.length !== 0;
  }

  public render() {
    let isAgencySelected = false;

    const isCreatePage = this.props.location?.pathname.includes("create")
      || this.props.location?.pathname.includes("contract/extend")
      || this.props.location?.pathname.includes("finance/charge")
      || (this.props.location?.pathname.includes("unit") && this.props.location?.pathname.includes("pay-charges"))
      || this.props.location?.pathname.includes("transaction-file/update");

      // we should not show link icon if agency selected
    if (this.state.lastSelectedEntity?.nameForUrl === "company" &&
        this.state.lastSelectedEntity?.id === this.getAgency()?.id) {
      isAgencySelected = true;
    }

    return (
      <div style={{
        display: this.props.isInlineBlock === true ? "inline-block" : "block",
        width: this.state.containerWidth,
        position: "relative",
        height: this.props.height || "auto"
      }}>
        <div className="clear-button-container">
          {this.state.showTextField &&
            <TextField
              autoComplete="off"
              name={this.props.name}
              className={"form-element full-size " + this.props.className}
              inputProps={{ref: input => this.ref = input}}
              type="text"
              onFocus={this.onFocus}
              onChange={this.onChange}
              value={this.state.searchText}
              label={this.config.labelText  && this.state.searchText && this.state.searchText !== "" ? this.config.labelText : this.config.floatingLabelText}
              autoFocus={this.state.autoFocus}
              onBlur={this.onBlur}
              disabled={this.props.disabled}
              variant="standard"
              style={{ width: this.state.width }}
              error={!!this.state.error}
            />
          }
          {!!this.state.error && <div className="component-error-text">{this.state.error}</div>}
          {this.state.hasSelectedEntity === true && !this.props.disabled && (
            <div className="icon icon-ic-close clear-button" onClick={this.onClear.bind(this)}></div>
          )}
          {this.state.lastSelectedEntity && !isAgencySelected && !this.props.hideClickThroughLink && !isCreatePage && (
            <IconButton className="icon-button-wrapper" style={{color: "#b2b2b2", position: "absolute", right: "-42px", top: "10px", cursor: "pointer"}}>
              <div
                className="icon icon-ic-open-in-new" onClick={() => this.redirect(this.config.linkedObjectUrl + this.state.lastSelectedEntity.id)}
              >
              </div>
            </IconButton>
          )}
        </div>

        <div
          style={{
            display: this.state.display,
            width: this.props.forceFullwidthDropdown === true ? "100%" : this.state.width,
            ...this.props?.dropdownStyles
          }}
          className={`${this.props.styleInModal ? this.props.styleInModal : ""} ${this.props.additionalClasses ? this.props.additionalClasses : ""} lookup-result-container abstract-lookup`}>
          {this.showFields()}
          {
            this.config.disableEntityCreation === false && (
              <div
                className="lookup-result-button-wrapper">
                <Button
                  color="primary"
                  onMouseUp={() => {
                    if (this.shouldRedirectToCreatePage() === true) {
                      return this.redirectToCreatePage();
                    }
                    return this.openModal();
                  }}
                  onMouseDown={this.setClickStarted.bind(this)}
                >
                  {this.config.buttonLabel}
                </Button>
              </div>
            )
          }
        </div>
      </div>
    );
  }
}

export default AbstractLookup;
